import { ConditionEndpoint } from "@/views/loyalty/shared/endpoint_services/condition-endpoint-service"

export class ConditionService {
    constructor () {
        this.conditionEndpoint = new ConditionEndpoint()
    }

    async createCondition (conditionCreate) {
        if (!conditionCreate.value) {
            conditionCreate.value = []
        }
        if (!Array.isArray(conditionCreate.value)) {
            conditionCreate.value = conditionCreate.value.split(',')
        }
        const conditionCreated = await this.conditionEndpoint.create_condition(conditionCreate)
        return conditionCreated
    }

    async deleteCondition (conditionId) {
        return this.conditionEndpoint.delete_condition(conditionId)
    }

    async getCondition (conditionId) {
        return this.conditionEndpoint.read_condition(conditionId)
    }

    async getConditions (ruleId) {
        return this.conditionEndpoint.read_conditions(ruleId)
    }

    async updateCondition (conditionId, conditionUpdate) {
        if (!conditionUpdate.value) {
            conditionUpdate.value = []
        }
        if (!Array.isArray(conditionUpdate.value)) {
            conditionUpdate.value = conditionUpdate.value.split(',')
        }
        const conditionUpdated = await this.conditionEndpoint.update_condition(conditionId, conditionUpdate)
        return conditionUpdated
    }

    stringToArray (value) {
        if (!Array.isArray(value)) {
            value = value.split(',')
            return value
        }
    }
}
